import {
  AdditionalOption,
  BasicOption,
  PropertyType,
} from '@/entities/room/@x/map'

export const MIN_USING_FEE = 0
export const MAX_USING_FEE = 1000000

export enum RoomCount {
  One = 'ONE',
  Two = 'TWO',
  ThreePlus = 'THREE_PLUS',
}

export enum PyeongSize {
  UNDER_FIVE = 'UNDER_FIVE', // 5평 미만
  FROM_FIVE_TO_TEN = 'FROM_FIVE_TO_TEN', // 5평 이상 10평 미만
  RANGE_TEN = 'RANGE_TEN', // 10평대
  RANGE_TWENTY = 'RANGE_TWENTY', // 20평대
  RANGE_THIRTY = 'RANGE_THIRTY', // 30평대
  OVER_FORTY = 'OVER_FORTY', // 40평 이상
}

export enum Floor {
  SEMI_BASEMENT = 'SEMI_BASEMENT', // 반지하
  FIRST_FLOOR = 'FIRST_FLOOR', // 1층
  FROM_SECOND_TO_NINE = 'FROM_SECOND_TO_NINE', // 2층 이상 9층 미만
  OVER_TEN = 'OVER_TEN', // 10층 이상
}

export enum PopularOption {
  PARKING = 'PARKING', // 주차 가능
  ELEVATOR = 'ELEVATOR', // 엘리베이터
  PET_ALLOWED = 'PET_ALLOWED', // 반려동물 동반
  DUPLEX_STRUCTURE = 'DUPLEX_STRUCTURE', // 복층
}

export enum RoomDiscount {
  EARLY = 'EARLY', // 빠른 입주 할인
  LONG_TERM = 'LONG_TERM', // 장기 계약 할인
}

export const ROOM_COUNT_MAP = {
  [RoomCount.One]: '1개',
  [RoomCount.Two]: '2개',
  [RoomCount.ThreePlus]: '3개 이상',
}

export const PYEONG_SIZE_MAP: Record<PyeongSize, string> = {
  [PyeongSize.UNDER_FIVE]: '5평 이하',
  [PyeongSize.FROM_FIVE_TO_TEN]: '5평 ~ 10평',
  [PyeongSize.RANGE_TEN]: '10평대',
  [PyeongSize.RANGE_TWENTY]: '20평대',
  [PyeongSize.RANGE_THIRTY]: '30평대',
  [PyeongSize.OVER_FORTY]: '40평 이상',
}

export const PROPERTY_TYPE_MAP: Record<PropertyType, string> = {
  [PropertyType.OFFICETEL]: '오피스텔',
  [PropertyType.APARTMENT]: '아파트',
  [PropertyType.VILLA]: '연립빌라',
  [PropertyType.DETACHED]: '단독주택',
  [PropertyType.STUDIO]: '원룸건물',
  [PropertyType.MIXED_USE]: '상가주택',
  [PropertyType.GOSIWON]: '고시원',
  [PropertyType.HOTEL]: '호텔',
  [PropertyType.SHARE_HOUSE]: '쉐어하우스',
  [PropertyType.VACATION_HOME]: '펜션',
  [PropertyType.GUEST_HOUSE]: '게스트하우스',
  [PropertyType.MOTEL]: '모텔여관',
}

export const POPULAR_OPTION_MAP: Record<PopularOption, string> = {
  [PopularOption.PARKING]: '주차 공간',
  [PopularOption.ELEVATOR]: '엘리베이터',
  [PopularOption.PET_ALLOWED]: '반려동물 동반',
  [PopularOption.DUPLEX_STRUCTURE]: '복층',
}

export const BASIC_OPTION_MAP: Record<BasicOption, string> = {
  [BasicOption.REFRIGERATOR]: '냉장고',
  [BasicOption.WASHING_MACHINE]: '세탁기',
  [BasicOption.AIR_CONDITIONER]: '에어컨',
  [BasicOption.TV]: 'TV',
  [BasicOption.WIFI]: '와이파이',
  [BasicOption.SINK]: '싱크대',
  [BasicOption.GAS_STOVE]: '가스레인지',
  [BasicOption.INDUCTION]: '인덕션',
  [BasicOption.BED]: '침대',
}

export const ADDITIONAL_OPTION_MAP: Record<AdditionalOption, string> = {
  [AdditionalOption.DOOR_LOCK]: '도어락',
  [AdditionalOption.CCTV]: 'CCTV',
  [AdditionalOption.MANAGEMENT_OFFICE]: '관리실',
  [AdditionalOption.DINING_TABLE]: '식탁',
  [AdditionalOption.MICROWAVE]: '전자레인지',
  [AdditionalOption.RICE_COOKER]: '전기밥솥',
  [AdditionalOption.WATER_PURIFIER]: '정수기',
  [AdditionalOption.SOFA]: '소파',
  [AdditionalOption.DESK]: '책상',
  [AdditionalOption.CLOSET]: '옷장',
  [AdditionalOption.SHOE_RACK]: '신발장',
  [AdditionalOption.VANITY]: '화장대',
  [AdditionalOption.BATHTUB]: '욕조',
  [AdditionalOption.BIDET]: '비데',
  [AdditionalOption.DRYER]: '건조기',
  [AdditionalOption.BALCONY]: '발코니/베란다',
  [AdditionalOption.DRESSING_ROOM]: '드레스룸',
  [AdditionalOption.CABLE_TV]: '케이블 TV',
  [AdditionalOption.CURTAINS]: '커튼',
  [AdditionalOption.AIR_PURIFIER]: '공기청정기',
  [AdditionalOption.PET_ALLOWED]: '반려동물 동반',
}

export const ROOM_DISCOUNT_MAP: Record<RoomDiscount, string> = {
  [RoomDiscount.LONG_TERM]: '장기 계약 할인',
  [RoomDiscount.EARLY]: '즉시 입주 할인',
}
